import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
import parse from "html-react-parser";
import { Button } from "../../components/Button/Button";

const styles = require("./MemberPanel.module.scss");

const MemberPanel = (props) => {
  const {
    member: { photo, description = "", firstname, surname, jobTitle, cta },
  } = props;

  return (
    <div className={styles.memberPanel}>
      <div className={styles.photoWrap}>
        <div className={styles.breadCrumb}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            MEET OUR TEAM
          </a>
        </div>
        <GatsbyImage image={photo} className={styles.photo} />
      </div>
      <div className={styles.copy}>
        <h3>
          {firstname} {surname}
        </h3>
        <h5>{jobTitle} </h5>
        {parse(description)}
        {cta ? (
          <Button
            type="externalLink"
            label={cta.text}
            bkgColor="black"
            toPage={cta.link}
          />
        ) : null}
      </div>
    </div>
  );
};

export default MemberPanel;
